/**
 * Smart formatter for unit cost / unit price display.
 * Shows full meaningful precision (up to 7 decimals), trimming trailing zeros
 * but keeping at least 3 decimals for visual consistency.
 *
 * Examples:
 *   0.7936508  → "0.7936508"
 *   0.794      → "0.794"
 *   12         → "12.000"
 *   0          → "0.000"
 */
export const fmtUnitPrice = (v: number | null | undefined): string => {
  if (v === null || v === undefined || isNaN(v)) return '0.000';
  const parts = v.toFixed(7).split('.');
  const intPart = parts[0];
  const decPart = (parts[1] || '').replace(/0+$/, '').padEnd(3, '0');
  return `${intPart}.${decPart}`;
};

/**
 * Standard money formatter (3 decimals) — Kuwaiti Dinar standard.
 * Used for totals, grand totals, and any monetary amount aggregations.
 */
export const fmtMoney = (v: number | null | undefined): string => {
  if (v === null || v === undefined || isNaN(v)) return '0.000';
  return v.toFixed(3);
};
